import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M17 5H3v13h14V5zM2 4v15h16V4H2z" /><path d="M13 8V4a3 3 0 10-6 0v4H6V4a4 4 0 118 0v4h-1z" /></svg>;